<ng-container *ngIf="state$ | async as state">
  <div [class.column--hidden]="!(isSubCategorySelected$ | async)"
       [class.column--round]="!(activeSubCategory$ | async)?.teasers?.length || !areTeasersVisible$"
       class="flyout2-column column-3"
       data-cy="navigation-flyout-column-3"
  >
    <ul class="structure">
      <li *ngFor="let category of navigation$ | async; index as i"
          [attr.aria-label]="category?.label"
          [attr.data-cy]="(selectedCategory$ | async)?.label"
          [attr.data-target]="category?.label?.toLocaleLowerCase()"
          [class.open]="(selectedCategory$ | async)?.label === category?.label"
          role="menuitem"
      >
        <ul class="structure">
          <ng-container *ngIf="category?.label === products || category?.label === applications; else noFilters">
            <li *ngFor="let filter of category?.children; index as i"
                [attr.aria-label]="filter?.label"
                [attr.data-cy]="(activeSubCategory$ | async)?.label"
                [class.open]="(activeFilter$ | async)?.label === filter?.label"
                role="menuitem"
            >
              <ng-container *ngFor="let subCategory of filter?.children">
                <ul *ngIf="subCategory.children?.length"
                    [class.d-none]="(activeSubCategory$ | async)?.label !== subCategory?.label"
                    class="nav"
                >
                  <li [class.current]="isCurrentRoute(subCategory?.url)">
                    <mb-category-navigation-link [category]="category"
                                                 [dataColor]="category?.label === products ? subCategory?.color || orange : orange"
                                                 [dataEventAction]="'Click ' + subCategory?.label + ' overview'"
                                                 [dataFilter]="category?.label + ' ' + (activeFilter$ | async )?.label"
                                                 [index]="i"
                                                 [route]="subCategory"
                                                 [subCategory]="subCategory"
                                                 [text]="subCategory?.label + ' overview'"
                                                 (closeNavigation)="closeEvent.emit($event)"
                    ></mb-category-navigation-link>
                  </li>
                  <ng-container *ngFor="let route of subCategory?.children; index as ri">
                    <li [class.current]="isCurrentRoute(route?.url)">
                      <mb-category-navigation-link [category]="category"
                                                   [dataFilter]="category?.label + ' ' + (activeFilter$ | async) ?.label"
                                                   [index]="ri"
                                                   [route]="route"
                                                   [subCategory]="subCategory"
                                                   [subcategoryIndex]="i"
                                                   (closeNavigation)="closeEvent.emit($event)"
                      ></mb-category-navigation-link>
                    </li>
                  </ng-container>
                </ul>
              </ng-container>
            </li>
          </ng-container>
          <ng-template #noFilters>
            <li *ngFor="let subCategory of category?.children; index as i"
                [attr.aria-label]="subCategory?.label"
                [class.open]="(selectedSubCategories$ | async)?.[category?.label] === subCategory"
                [id]="category?.label?.toLocaleLowerCase() + '_' + subCategory?.label?.toLocaleLowerCase().replaceAll(' ', '-')"
                data-cy="navigation-flyout-column-3-subcategory"
                role="menuitem"
            >
              <ul class="nav">
                <div [ngClass]="{'external-url': subCategory.isExternalUrl}">
                    <li [class.current]="isCurrentRoute(subCategory?.url)" >
                        <mb-category-navigation-link [category]="category"
                                                     [dataColor]="category?.label === products ? subCategory?.color || orange : orange"
                                                     [dataEventAction]="'Click ' + subCategory?.label + ' overview'"
                                                     [route]="subCategory"
                                                     [subCategory]="subCategory"
                                                     [text]="subCategory?.label + ' overview'"
                                                     (click)="closeEvent.emit($event)"
                        ></mb-category-navigation-link>
                    </li>
                    <span *ngIf="subCategory.isExternalUrl">
                        <img src="/assets/icons/svg/external-link.svg" />
                    </span>
                </div>
                <ng-container *ngFor="let route of subCategory?.children; index as ri">
                <div [ngClass]="{'external-url': route.isExternalUrl}">
                    <li [class.current]="isCurrentRoute(route?.url)">
                        <mb-category-navigation-link [category]="category"
                                                     [index]="ri"
                                                     [route]="route"
                                                     [subCategory]="subCategory"
                                                     [subcategoryIndex]="i"
                                                     (closeNavigation)="closeEvent.emit($event)"
                        ></mb-category-navigation-link>
                    </li>
                    <span *ngIf="route.isExternalUrl">
                        <img src="/assets/icons/svg/external-link.svg" />
                    </span>
                    </div>
                </ng-container>
              </ul>
            </li>
          </ng-template>
        </ul>
      </li>
    </ul>
  </div>
</ng-container>
